import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#9ca3af",
    "font-size": "12px",
    "margin-left": "4px"
  }
}, "(可多选)", -1);
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "8px"
  }
}, "上传", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#9ca3af",
    "font-size": "12px",
    "margin-top": "4px"
  }
}, [/*#__PURE__*/_createTextVNode(" 支持 PNG, JPG 格式，最多 3 张，可直接 "), /*#__PURE__*/_createElementVNode("kbd", {
  style: {
    "display": "inline-block",
    "padding": "1px 5px",
    "border": "1px solid #d1d5db",
    "border-radius": "4px",
    "background": "#f9fafb",
    "font-size": "11px",
    "color": "#374151",
    "font-family": "inherit",
    "line-height": "1.5"
  }
}, " Ctrl + V "), /*#__PURE__*/_createTextVNode(" 粘贴截图 ")], -1);
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { PlusOutlined, WarningOutlined } from '@ant-design/icons-vue';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'OtherReasonModal',
  props: {
    modelVisible: {
      type: Boolean
    },
    currentRecord: null,
    reasonMap: null
  },
  emits: ['update:modelVisible', 'confirm', 'cancel'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const localRecord = ref({
      receivedResCode: [],
      receivedResMsg: '',
      remark: ''
    });
    const fileList = ref([]);
    const previewVisible = ref(false);
    const previewCurrent = ref(0);
    const initializeData = record => {
      var _record$receivedResEx, _record$receivedResEx2, _record$receivedResEx3;
      if (!record) return;
      if (record !== null && record !== void 0 && (_record$receivedResEx = record.receivedResExtInfo) !== null && _record$receivedResEx !== void 0 && (_record$receivedResEx = _record$receivedResEx.receivedResList) !== null && _record$receivedResEx !== void 0 && _record$receivedResEx.length) {
        localRecord.value.receivedResCode = record.receivedResExtInfo.receivedResList.map(item => String(item.receivedResCode));
      } else {
        localRecord.value.receivedResCode = [];
      }
      localRecord.value.receivedResMsg = '';
      localRecord.value.remark = (record === null || record === void 0 || (_record$receivedResEx2 = record.receivedResExtInfo) === null || _record$receivedResEx2 === void 0 ? void 0 : _record$receivedResEx2.supplementRemark) || '';
      if (record !== null && record !== void 0 && (_record$receivedResEx3 = record.receivedResExtInfo) !== null && _record$receivedResEx3 !== void 0 && (_record$receivedResEx3 = _record$receivedResEx3.imageList) !== null && _record$receivedResEx3 !== void 0 && _record$receivedResEx3.length) {
        fileList.value = record.receivedResExtInfo.imageList.map((url, index) => ({
          uid: `-${index}`,
          name: `图片${index + 1}`,
          status: 'done',
          url,
          fileUrl: url
        }));
      } else {
        fileList.value = [];
      }
    };
    watch(() => props.modelVisible, newVal => {
      if (newVal) initializeData(props.currentRecord);
    });
    // 过滤掉【-】(0) 和【其他】(60)，保留其余选项
    const reasonOptions = computed(() => {
      if (!props.reasonMap) return [];
      return Object.entries(props.reasonMap).filter(([key]) => key !== '0' && key !== '60').map(([value, label]) => ({
        value,
        label
      }));
    });
    const handleReceivedResCodeChange = values => {
      localRecord.value.receivedResCode = values;
    };
    const handlePreview = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      previewCurrent.value = fileList.value.findIndex(f => f.uid === file.uid);
      previewVisible.value = true;
    };
    const doUpload = async (file, uid) => {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('accessAttribute', '1');
        formData.append('businessId', props.currentRecord.id);
        formData.append('businessType', 'ACCOUNT_BILL');
        const response = await uploadAuditScreenshot(formData);
        const fileData = response.data;
        const item = fileList.value.find(f => f.uid === uid);
        if (item) {
          item.status = 'done';
          item.url = fileData.fileUrl;
          item.fileUrl = fileData.fileUrl;
        }
      } catch {
        const item = fileList.value.find(f => f.uid === uid);
        if (item) item.status = 'error';
      }
    };
    const handleUploadImage = async options => {
      const {
        file,
        onSuccess,
        onError
      } = options;
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('accessAttribute', '1');
        formData.append('businessId', props.currentRecord.id);
        formData.append('businessType', 'ACCOUNT_BILL');
        const response = await uploadAuditScreenshot(formData);
        const fileData = response.data;
        onSuccess(response);
        const fileItem = fileList.value.find(item => item.name === file.name);
        if (fileItem) fileItem.fileUrl = fileData.fileUrl;
      } catch (error) {
        onError(error);
      }
    };
    const handlePaste = e => {
      var _e$clipboardData;
      if (!props.modelVisible || fileList.value.length >= 3) return;
      const items = (_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.items;
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.startsWith('image/')) {
          const blob = items[i].getAsFile();
          if (!blob) continue;
          const uid = `paste-${Date.now()}`;
          const fileName = `截图_${uid}.png`;
          const file = new File([blob], fileName, {
            type: blob.type
          });
          fileList.value.push({
            uid,
            name: fileName,
            status: 'uploading',
            originFileObj: file
          });
          doUpload(file, uid);
          break;
        }
      }
    };
    onMounted(() => document.addEventListener('paste', handlePaste));
    onBeforeUnmount(() => document.removeEventListener('paste', handlePaste));
    const handleOtherReasonConfirm = () => {
      const receivedResList = localRecord.value.receivedResCode.map(code => ({
        receivedResCode: code,
        receivedResMsg: props.reasonMap[code] || ''
      }));
      emit('confirm', {
        currentRecord: {
          ...props.currentRecord,
          receivedResExtInfo: {
            ...(localRecord.value.receivedResExtInfo || {}),
            receivedResList,
            imageList: fileList.value.map(f => f.fileUrl).filter(Boolean),
            supplementRemark: localRecord.value.remark || ''
          }
        },
        fileUrls: fileList.value.map(f => f.fileUrl).filter(Boolean)
      });
    };
    const handleOtherReasonCancel = () => {
      emit('cancel');
      emit('update:modelVisible', false);
    };
    const getBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    expose({
      initializeData
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_image_preview_group = _resolveComponent("a-image-preview-group");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modelVisible,
        onOk: handleOtherReasonConfirm,
        onCancel: handleOtherReasonCancel,
        "ok-text": "保存说明",
        centered: "",
        width: "520px"
      }, {
        title: _withCtx(() => [_createVNode(_unref(WarningOutlined), {
          style: {
            "color": "#faad14",
            "margin-right": "8px"
          }
        }), _createTextVNode(" 收款异常说明 ")]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          layout: "vertical"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, null, {
            label: _withCtx(() => [_createTextVNode(" 异常原因 "), _hoisted_1]),
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: localRecord.value.receivedResCode,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => localRecord.value.receivedResCode = $event),
              popupClassName: "reason-select-popup",
              options: _unref(reasonOptions),
              mode: "multiple",
              placeholder: "请选择异常标签...",
              onChange: handleReceivedResCodeChange
            }, null, 8, ["value", "options"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "补充说明"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: localRecord.value.remark,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => localRecord.value.remark = $event),
              rows: 3,
              maxlength: 200,
              "show-count": "",
              placeholder: "请输入补充说明..."
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "附件凭证"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_upload, {
              "file-list": fileList.value,
              "onUpdate:file-list": _cache[2] || (_cache[2] = $event => fileList.value = $event),
              "list-type": "picture-card",
              onPreview: handlePreview,
              customRequest: handleUploadImage
            }, {
              default: _withCtx(() => [fileList.value.length < 3 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(PlusOutlined)), _hoisted_3])) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["file-list"]), _hoisted_4, _createVNode(_component_a_image_preview_group, {
              preview: {
                visible: previewVisible.value,
                current: previewCurrent.value,
                onVisibleChange: v => previewVisible.value = v
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, idx) => {
                return _openBlock(), _createBlock(_component_a_image, {
                  key: idx,
                  src: file.url || file.preview,
                  style: {
                    "display": "none"
                  }
                }, null, 8, ["src"]);
              }), 128))]),
              _: 1
            }, 8, ["preview"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["open"]);
    };
  }
});